module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_18-20e6a57615345445a30e21f234eb6917.jpg";